export default "__VITE_ASSET__CmUqaQmW__"